<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Utleiers adresse</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <TextInput v-model="stepValues.textFields" @update-fields="updateFields"></TextInput>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  computed: {
    finished: function() {
      if (
        Boolean(this.stepValues.textFields.street.value) &&
        Boolean(this.stepValues.textFields.zip.value) &&
        Boolean(this.stepValues.textFields.city.value)
      ) {
        return true;
      } else {
        this.$emit("error", "Alle felter må ha en verdi");
        return false;
      }
    }
  }
};
</script>
